import { createFileRoute } from "@tanstack/react-router";
import MedicalStudyGuide from "@/pages/resources/MedicalStudyGuide";

export const Route = createFileRoute("/learn/medical-study-ai")({
  head: () => ({
    meta: [
        {
            "title": "Studying for Medical School with AI: The Complete Guide | System Atlas"
        },
        {
            "name": "description",
            "content": "How to use AI tools to study for medical school (PASS/PACES/USMLE). Subject-specific strategies, study schedules, and proven retention techniques."
        },
        {
            "property": "og:title",
            "content": "Studying for Medical School with AI: The Complete Guide | System Atlas"
        },
        {
            "property": "og:description",
            "content": "How to use AI tools to study for medical school (PASS/PACES/USMLE). Subject-specific strategies, study schedules, and proven retention techniques."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/medical-study-ai"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Studying for Medical School with AI: The Complete Guide | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "How to use AI tools to study for medical school (PASS/PACES/USMLE). Subject-specific strategies, study schedules, and proven retention techniques."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/medical-study-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/medical-study-ai"
        }
    ],
  }),
  component: MedicalStudyGuide,
});
